export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "data.worker.ba686358d92b205010f4.worker.js");
}
